import { all, fork } from "redux-saga/effects";
import { clientsSaga } from "./clients/clientsSaga.js";
import { templatesSaga } from "./templates/templatesSaga.js";

export function* rootSaga() {
  yield all([fork(clientsSaga), fork(templatesSaga)]);
}
